import type { BoardObjectV2 } from "@bezpart-board/shared";

const GROUP_META_KEY = "groupId";

function metaOf(obj: BoardObjectV2): Record<string, unknown> {
  return (obj.meta && typeof obj.meta === "object" ? obj.meta : {}) as Record<string, unknown>;
}

export function objectGroupId(obj: BoardObjectV2): string | null {
  const meta = metaOf(obj);
  const value = meta[GROUP_META_KEY];
  return typeof value === "string" && value.trim() ? value : null;
}

export function withGroupIdMeta(
  obj: BoardObjectV2,
  groupId: string | null
): Record<string, unknown> | null {
  const next = { ...metaOf(obj) };
  if (groupId) next[GROUP_META_KEY] = groupId;
  else delete next[GROUP_META_KEY];
  return Object.keys(next).length ? next : null;
}

/** Если выбран объект из группы — в selection добавляется вся группа. */
export function expandSelectionToWholeGroups(
  selectedIds: string[],
  objects: BoardObjectV2[]
): string[] {
  if (!selectedIds.length) return [];
  const byId = new Map(objects.map((o) => [o.id, o] as const));
  const selected = new Set(selectedIds.filter(Boolean));
  const groupIds = new Set<string>();

  for (const id of selected) {
    const obj = byId.get(id);
    if (!obj) continue;
    const gid = objectGroupId(obj);
    if (gid) groupIds.add(gid);
  }
  if (!groupIds.size) return [...selected];

  for (const obj of objects) {
    const gid = objectGroupId(obj);
    if (gid && groupIds.has(gid)) selected.add(obj.id);
  }
  return [...selected];
}

/** Для clone/paste: oldGroupId -> newGroupId, чтобы копия была отдельной группой. */
export function remapGroupIdForClone(
  source: BoardObjectV2,
  groupMap: Map<string, string>
): string | null {
  const gid = objectGroupId(source);
  if (!gid) return null;
  const cached = groupMap.get(gid);
  if (cached) return cached;
  const next = crypto.randomUUID();
  groupMap.set(gid, next);
  return next;
}
